import React from "react";
import { SEARCH_TERMS } from "../data/searchTerms";

const PopularSearches = () => (
  <section id="popular-searches" className="bg-neutral-50 border-t border-neutral-200 py-14">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <h2 className="text-lg font-bold text-neutral-800 mb-2">Popular Searches</h2>
      <p className="text-sm text-neutral-500 mb-6 max-w-3xl">
        Guests find Auracrest Haven while searching for stays, rooms, cottages and resorts with
        home-cooked food across Munnar, Anachal, Muthuvankudy and Sengulam Dam.
      </p>
      <div className="flex flex-wrap gap-x-2 gap-y-2">
        {SEARCH_TERMS.map((t) => (
          <span
            key={t}
            className="text-[11px] leading-none text-neutral-500 hover:text-[#17a89b] bg-white border border-neutral-200 rounded-full px-2.5 py-1.5 transition-colors"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default PopularSearches;
